module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "confirm-layout"
  }, [(_vm.currentDrugInDevice) ? _c('div', {
    staticClass: "alert alert-success"
  }, [_vm._v("\n    此藥盒目前數量/上限: " + _vm._s(_vm.currentDrugInDevice.stock) + " / " + _vm._s(_vm.currentDrugInDevice.max_stock) + "\n  ")]) : _c('div', {
    staticClass: "alert alert-success"
  }, [_vm._v("\n    補藥至未使用藥盒\n  ")]), _vm._v(" "), (_vm.currentProgress === 'setPatch') ? _c('ConfirmText', {
    attrs: {
      "inputLabel": '確認批號',
      "defaultContent": _vm.defaultPatchNumber,
      "editable": _vm.patchEditable
    },
    on: {
      "setText": _vm.getPatch
    }
  }) : _vm._e(), _vm._v(" "), (_vm.currentProgress === 'setMaxAmount') ? _c('MaxStockSet', {
    on: {
      "setMaxAmountData": _vm.getMaxAmountData
    }
  }) : _vm._e(), _vm._v(" "), (_vm.currentProgress === 'setExpirationDate') ? _c('ConfirmExpirationDate', {
    attrs: {
      "defaultExpirationDate": _vm.defaultExpirationDate,
      "editable": _vm.dateEditable
    },
    on: {
      "setExpirationDate": _vm.getExpirationDate
    }
  }) : _vm._e(), _vm._v(" "), (_vm.currentProgress === 'setRefillNum') ? _c('PackAndPieceSet', {
    attrs: {
      "defaultAmount": _vm.defaultRefillAmount,
      "inputLabel": '補充數量'
    },
    on: {
      "setNum": _vm.getPatchAndPieceData
    }
  }) : _vm._e(), _vm._v(" "), (_vm.currentProgress === 'rxCheck') ? _c('rx-check-barcode', {
    on: {
      "confirmRx": _vm.confirmRx
    }
  }) : _vm._e(), _vm._v(" "), (_vm.currentProgress === 'action') ? _c('ActionWrap', {
    attrs: {
      "startType": _vm.startType,
      "amountPayload": _vm.amountPayload
    },
    on: {
      "setActionData": _vm.getActionData
    }
  }) : _vm._e(), _vm._v(" "), (_vm.currentProgress === 'finish') ? _c('Loader') : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-13ae8021","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/RefillDrugFlow/ConfirmFlow.vue
// module id = 1396
// module chunks = 1